/**
 * Display label for an endpoint: name → summary → path.
 *
 * Extracted endpoints have no `name`, only a `summary`, so a plain `name || path` fallback
 * would show a bare path for every imported endpoint. Empty strings count as absent —
 * `updateEndpoint` writes `name = ""` when a user edits method/path without naming it.
 */
export const getEndpointLabel = (endpoint) => {
  if (!endpoint) return "";

  const name = typeof endpoint.name === "string" ? endpoint.name.trim() : "";
  if (name) return name;

  const summary = typeof endpoint.summary === "string" ? endpoint.summary.trim() : "";
  if (summary) return summary;

  return endpoint.path || "";
};

/** `gradingIssues` is persisted as a JSON string; returns a plain array. */
export const parseGradingIssues = (gradingIssues) => {
  if (!gradingIssues) return [];
  if (Array.isArray(gradingIssues)) return gradingIssues;

  if (typeof gradingIssues === "string") {
    try {
      const parsed = JSON.parse(gradingIssues);
      return Array.isArray(parsed) ? parsed : [String(parsed)];
    } catch {
      return [gradingIssues];
    }
  }

  return [];
};
